(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["b2h-saved-gifts"] && !Shopify.designMode) return;
  try {
    
  class B2hSavedGifts extends HTMLElement {
    connectedCallback() {
      this.searchUrl = this.dataset.searchUrl;
      this.sectionId = this.dataset.sectionId;
      this.storageKey = this.dataset.storageKey || 'glozin__wishlist-items';
      this.handleWishlistChange = this.handleWishlistChange.bind(this);
      this.refreshElements();
      this.bindRetry();
      window.addEventListener('b2h:wishlist-change', this.handleWishlistChange);
      this.renderSavedItems();
    }

    disconnectedCallback() {
      window.removeEventListener('b2h:wishlist-change', this.handleWishlistChange);
    }

    refreshElements() {
      this.main = this.querySelector('.wishlist-page-main');
      this.loading = this.querySelector('[data-b2h-saved-loading]');
      this.empty = this.querySelector('[data-b2h-saved-empty]');
      this.error = this.querySelector('[data-b2h-saved-error]');
      this.grid = this.querySelector('[data-b2h-saved-grid]');
      this.count = this.querySelector('[data-b2h-saved-count]');
      this.countLabel = this.querySelector('[data-b2h-saved-count-label]');
      this.announcement = this.querySelector('[data-b2h-saved-announcement]');
    }

    bindRetry() {
      this.querySelector('[data-b2h-saved-retry]')?.addEventListener('click', () => {
        this.renderSavedItems({ announce: true });
      });
    }

    getSavedIds() {
      try {
        const saved = JSON.parse(localStorage.getItem(this.storageKey) || '[]');
        if (!Array.isArray(saved)) return [];
        return [...new Set(saved.filter(Boolean).map(String))];
      } catch (error) {
        localStorage.removeItem(this.storageKey);
        return [];
      }
    }

    setSavedIds(savedIds) {
      localStorage.setItem(this.storageKey, JSON.stringify(savedIds));
      window.wishlistHeader?.init?.();
    }

    updateCount(count) {
      if (this.count) this.count.textContent = String(count);
      if (this.countLabel) this.countLabel.textContent = count === 1 ? 'piece saved' : 'pieces saved';
    }

    announce(message) {
      if (!this.announcement || !message) return;
      this.announcement.textContent = '';
      window.requestAnimationFrame(() => {
        this.announcement.textContent = message;
      });
    }

    showState(state) {
      if (this.loading) this.loading.hidden = state !== 'loading';
      if (this.empty) this.empty.hidden = state !== 'empty';
      if (this.error) this.error.hidden = state !== 'error';
      if (this.grid) this.grid.hidden = state !== 'results';
    }

    showEmpty({ focus = false } = {}) {
      this.updateCount(0);
      this.showState('empty');
      if (focus) {
        this.empty?.querySelector('a, button')?.focus();
      }
    }

    handleWishlistChange(event) {
      const savedIds = Array.isArray(event.detail?.items) ? event.detail.items.map(String) : this.getSavedIds();
      this.updateCount(savedIds.length);

      const productId = String(event.detail?.productId || '');
      if (event.detail?.action === 'remove' && productId) {
        this.querySelector(`.wishlist-list[data-product-id="${productId}"]`)?.remove();
      }

      const remainingItems = this.querySelectorAll('.wishlist-list').length;
      if (remainingItems === 0 && savedIds.length === 0) {
        this.showEmpty({ focus: true });
      }
    }

    orderItems(savedIds) {
      if (!this.grid) return;
      const itemMap = new Map(
        [...this.grid.querySelectorAll('.wishlist-list[data-product-id]')].map((item) => [item.dataset.productId, item])
      );
      [...savedIds].reverse().forEach((productId) => {
        const item = itemMap.get(productId);
        if (item) this.grid.appendChild(item);
      });
    }

    async renderSavedItems({ announce = false } = {}) {
      if (!this.main || !this.searchUrl || !this.sectionId) return;

      const savedIds = this.getSavedIds();
      this.updateCount(savedIds.length);
      if (savedIds.length === 0) {
        this.showEmpty();
        return;
      }

      this.showState('loading');

      const params = new URLSearchParams({
        section_id: this.sectionId,
        type: 'product',
        q: `id:${savedIds.join(' OR id:')}`
      });
      params.set('options[unavailable_products]', 'last');

      try {
        const response = await fetch(`${this.searchUrl}?${params.toString()}`);
        if (!response.ok) throw new Error(`Wishlist search failed: ${response.status}`);

        const html = await response.text();
        const documentFragment = new DOMParser().parseFromString(html, 'text/html');
        const fetchedMain = documentFragment.querySelector('.wishlist-page-main');
        const fetchedItems = documentFragment.querySelector('.wishlist-list-items');

        if (!fetchedMain || !fetchedItems) {
          this.setSavedIds([]);
          this.showEmpty();
          return;
        }

        this.main.innerHTML = fetchedMain.innerHTML;
        this.refreshElements();
        this.bindRetry();

        const renderedIds = new Set(
          [...this.querySelectorAll('.wishlist-list[data-product-id]')].map((item) => item.dataset.productId)
        );
        const validSavedIds = savedIds.filter((productId) => renderedIds.has(productId));
        if (validSavedIds.length !== savedIds.length) {
          this.setSavedIds(validSavedIds);
        }

        if (validSavedIds.length === 0) {
          this.showEmpty();
          return;
        }

        this.orderItems(validSavedIds);
        this.updateCount(validSavedIds.length);
        this.showState('results');
        window.initLazyloadItem?.();
        window.wishlistHeader?.init?.();
        if (announce) this.announce('Saved gifts reloaded.');
      } catch (error) {
        console.error(error);
        this.showState('error');
      }
    }
  }

  if (!customElements.get('b2h-saved-gifts')) {
    customElements.define('b2h-saved-gifts', B2hSavedGifts);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["b2h-v3-discovery"] && !Shopify.designMode) return;
  try {
    
  // Keep the complete keyboard-focused chip visible without moving the page vertically.
  document.addEventListener('focusin', (event) => {
    const link = event.target.closest?.('.b2h-discovery__task');
    const nav = link?.closest('.b2h-discovery__tasks');
    if (!nav || nav.scrollWidth <= nav.clientWidth) return;
    const item = link.getBoundingClientRect();
    const bounds = nav.getBoundingClientRect();
    const offset = item.left < bounds.left ? item.left - bounds.left : item.right > bounds.right ? item.right - bounds.right : 0;
    if (offset) nav.scrollBy({ left: offset, behavior: 'instant' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["b2h-v3-product-specifications"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('b2h:variant-change', (event) => {
    const specifications = document.querySelector('[data-b2h-product-specifications]');
    const variant = event.detail?.variant;
    if (!specifications || !variant) return;

    const skuRow = specifications.querySelector('[data-b2h-product-specification-sku-row]');
    const sku = specifications.querySelector('[data-b2h-product-specification-sku]');
    if (skuRow && sku) {
      sku.textContent = variant.sku || '';
      skuRow.hidden = !variant.sku;
    }

    const availability = specifications.querySelector('[data-b2h-product-specification-availability]');
    if (availability) {
      availability.textContent = variant.available
        ? availability.dataset.availableText
        : availability.dataset.unavailableText;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
